import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
const store=new Vuex.Store({
    state:{
        // baseURL:'http://insurev2.yklmartspace.com/api/home/',//测试地址
        //baseURL:'http://wap.cnguanai.com/api/home/',//线上地址
        baseURL:'http://wap.careinsur.com/api/home/',//线上地址
        isLogin:false,
        token:null,      
        userInfo:null,
        CommonInfo:null,//详情页公共信息，服务约定，理赔流程
        phones:null,    //公共电话，客服热线，退保，理赔
        clientInfo:null,//存储查看的客户的信息
        categoryList:null,//普通用户产品库 类别
        activeName:0,//普通用户产品库  选中类别
    },
    getters:{//类似computed属性

    },
    mutations: {
        SET_COMMONINFO: (state, CommonInfo) => {
          state.CommonInfo =CommonInfo 
        },
        SET_PHONES: (state, phones) => {
          state.phones =phones 
        },
        SET_CLIENTINFO: (state, clientInfo) => {
          state.clientInfo =clientInfo 
        },
        SET_CATEGORYLIST:(state,categoryList)=>{
          state.categoryList =categoryList 
        },
        SET_ACTIVENAME:(state,activeName)=>{
          state.activeName =activeName 
        },
        SET_TOKEN: (state,userInfo) =>{
          state.token=userInfo.token;
          state.userInfo=userInfo;
          let info=JSON.stringify(userInfo);
          localStorage.setItem("guanai_userInfo",info);
        },
        LOGIN: (state,userInfo) =>{
          state.isLogin=true;
          state.token=userInfo.token;
          state.userInfo=userInfo;
          let info=JSON.stringify(userInfo);
          localStorage.setItem("guanai_userInfo",info);
          localStorage.removeItem("guanai_logout");
        },
        LOGOUT: (state) =>{
          state.isLogin=false;
          state.token=null;
          state.userInfo=null;
          localStorage.clear();
          localStorage.setItem("guanai_logout",true);
        }
    },
    getters: {
    }
})

export default store  //导出


// WEBPACK FOOTER //
// ./src/store/index.js